module.exports = __webpack_public_path__ + "img/07.acfeb24b.png";